module.exports = __webpack_public_path__ + "../resources/img/EF_Layer1.fa57936b.svg";